<section class="mod-page" data-module="settings">
  <header class="page-header">
    <div>
      <p class="eyebrow">Administration</p>
      <h1>User management</h1>
      <p class="muted" style="margin:.35rem 0 0">
        Create and update desk profiles. Email and mobile are used for OTP login (DM / Records Officer).
      </p>
    </div>
    @if (canManageUsers()) {
      <div class="btn-row">
        <button type="button" class="btn primary" (click)="openCreate()">+ Add user</button>
      </div>
    }
  </header>

  @if (message()) {
    <p class="toast">{{ message() }}</p>
  }

  <div class="table-wrap">
    <table>
      <thead>
        <tr>
          <th>User</th>
          <th>Email</th>
          <th>Mobile</th>
          <th>Role</th>
          <th>Department</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (u of users(); track u.id) {
          <tr>
            <td>{{ u.name }}</td>
            <td>{{ u.email || '—' }}</td>
            <td>{{ u.phone || '—' }}</td>
            <td><span class="pill">{{ roleLabel(u) }}</span></td>
            <td>{{ u.department }}</td>
            <td><span class="pill" [class.danger]="u.status !== 'Active'">{{ u.status }}</span></td>
            <td>
              <div class="btn-row">
                <button
                  type="button"
                  class="btn"
                  (click)="startEdit(u)"
                  [disabled]="!canManageUsers() || u.role === 'admin'"
                >
                  Edit
                </button>
                <button
                  type="button"
                  class="btn"
                  (click)="removeUser(u.id, u.name)"
                  [disabled]="!canManageUsers() || u.role === 'admin' || u.name === 'System Admin'"
                >
                  Remove
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</section>

@if (modalOpen()) {
  <div class="admin-overlay" (click)="closeModal()">
    <div
      class="admin-modal"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="modalMode() === 'edit' ? 'editUserTitle' : 'addUserTitle'"
      (click)="$event.stopPropagation()"
    >
      <header class="admin-modal-head">
        @if (modalMode() === 'edit') {
          <h3 id="editUserTitle">Edit user</h3>
        } @else {
          <h3 id="addUserTitle">Add user</h3>
        }
        <button type="button" class="admin-modal-close" (click)="closeModal()" aria-label="Close">×</button>
      </header>

      <div class="admin-modal-body">
        @if (modalMode() === 'create') {
          <div class="form-grid">
            <label>Username<input class="field" [(ngModel)]="newUsername" name="username" /></label>
            <label>Password<input class="field" type="password" [(ngModel)]="newPassword" name="password" /></label>
            <label>Display name<input class="field" [(ngModel)]="newDisplayName" name="displayName" /></label>
            <label>
              Role
              <select class="field" [(ngModel)]="newRole" name="role">
                @for (opt of createRoleOptions(); track opt.value) {
                  <option [value]="opt.value" [disabled]="opt.disabled">{{ opt.label }}</option>
                }
              </select>
            </label>
            <label>Department<input class="field" [(ngModel)]="newDepartment" name="department" /></label>
            <label>Email <span class="muted">(OTP)</span>
              <input class="field" type="email" [(ngModel)]="newEmail" name="email" placeholder="officer@example.com" />
            </label>
            <label>Mobile <span class="muted">(OTP)</span>
              <input class="field" type="tel" [(ngModel)]="newPhone" name="phone" placeholder="10-digit mobile" />
            </label>
          </div>
        } @else {
          <div class="form-grid">
            <label>Display name<input class="field" [(ngModel)]="editName" name="editName" /></label>
            <label>
              Role
              <select class="field" [(ngModel)]="editRole" name="editRole">
                @for (opt of editRoleOptions(); track opt.value) {
                  <option [value]="opt.value">{{ opt.label }}</option>
                }
              </select>
            </label>
            <label>Department<input class="field" [(ngModel)]="editDepartment" name="editDepartment" /></label>
            <label>Email <span class="muted">(OTP)</span>
              <input class="field" type="email" [(ngModel)]="editEmail" name="editEmail" placeholder="officer@example.com" />
            </label>
            <label>Mobile <span class="muted">(OTP)</span>
              <input class="field" type="tel" [(ngModel)]="editPhone" name="editPhone" placeholder="10-digit mobile" />
            </label>
            <label>New password <span class="muted">(optional)</span>
              <input class="field" type="password" [(ngModel)]="editPassword" name="editPassword" />
            </label>
          </div>
        }
      </div>

      <footer class="admin-modal-foot">
        <button type="button" class="btn" (click)="closeModal()" [disabled]="busy()">Cancel</button>
        @if (modalMode() === 'edit') {
          <button type="button" class="btn primary" (click)="saveEdit()" [disabled]="busy()">
            {{ busy() ? 'Saving…' : 'Save' }}
          </button>
        } @else {
          <button type="button" class="btn primary" (click)="createUser()" [disabled]="busy()">
            {{ busy() ? 'Creating…' : 'Create profile' }}
          </button>
        }
      </footer>
    </div>
  </div>
}
